import * as yup from 'yup';

export default yup.object().shape({
  username: yup.string().required(),
  password: yup.string().required(),
});
